// extracted by mini-css-extract-plugin
export default {"MediaWidget":"MediaWidget_MediaWidget__NHH4l"};